"use client";

import rippleEffect from "@/utils/rippleEffect";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React, { useEffect, useState } from "react";
import styles from "./layout.module.scss";
import { useRouter } from "next/navigation";
import Image from "next/image";

interface menuItemType {
  label: string;
  link: string;
  active: boolean;
  isCollapsable: boolean;
}

interface menuSubItemType {
  id: number;
  coin: string;
  persian_name: string;
  link: string;
}

const NavbarItems = [
  {
    label: "صفحه اصلی",
    link: "/",
    active: true,
    isCollapsable: false,
  },
  {
    label: "کوین‌ها",
    link: "/coins",
    active: true,
    isCollapsable: true,
  },
  {
    label: "پنل معاملاتی",
    link: `${process.env.APP_PANEL_URL}/trade/USDT_TMN`,
    active: true,
    isCollapsable: false,
  },
  {
    label: "اپلیکیشن موبایل",
    link: "/application",
    active: true,
    isCollapsable: false,
  },
  {
    label: "بلاگ اینوکس",
    link: "https://invex.ir/blog/",
    active: true,
    isCollapsable: false,
  },
  // {
  //   label: "دعوت از دوستان",
  //   link: "/invite",
  //   active: false,
  // },
  {
    label: "درباره ما",
    link: "/about",
    active: true,
    isCollapsable: false,
  },
];

const coins = [
  {
    id: 1,
    coin: "BTC",
    persian_name: "بیتکوین",
    link: "/coins/btc",
  },
  {
    id: 2,
    coin: "ETH",
    persian_name: "اتریوم",
    link: "/coins/eth",
  },
  {
    id: 3,
    coin: "USDT",
    persian_name: "تتر",
    link: "/coins/usdt",
  },
  {
    id: 4,
    coin: "",
    persian_name: "قیمت ارزهای دیجیتال",
    link: "/coins",
  },
];

export default function Header() {
  const path = usePathname();
  const router = useRouter();

  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [scrollTop, setScrollTop] = useState<number>(0);
  const [preScrollTop, setPreScrollTop] = useState<number>(0);
  const [collapsedMenuLabel, setCollapsedMenuLabel] = useState<string | null>(
    null,
  );
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window) {
      if (window.innerWidth < 1200) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
  }, []);

  let light: boolean = path === "/faq" ? true : false;

  const scrollHandler = () => {
    setScrollTop(document.documentElement.scrollTop);
  };

  useEffect(() => {
    if (!isMenuOpen) {
      const st = document.documentElement.scrollTop;

      if (st > Math.max(preScrollTop, 72) && !path.startsWith("/coins/")) {
        document
          .querySelector("body>header")
          ?.setAttribute("style", "transform: translateY(-72px);");
      } else if (st < Math.max(preScrollTop, 72)) {
        if (st < 72)
          if (path === "/")
            document
              .querySelector("body>header")
              ?.setAttribute("style", "background-color: transparent");
          else document.querySelector("body>header")?.removeAttribute("style");
        else document.querySelector("body>header")?.removeAttribute("style");
      }

      setPreScrollTop(scrollTop);
    }
  }, [scrollTop]);

  useEffect(() => {
    window.addEventListener("scroll", scrollHandler);
    setScrollTop(document.documentElement.scrollTop);
    setPreScrollTop(document.documentElement.scrollTop);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  const selectMenuItemHandler = (menuItemInfo: menuItemType) => {
    if (menuItemInfo.isCollapsable) {
      if (isMobile) {
        if (menuItemInfo.label === collapsedMenuLabel) {
          setCollapsedMenuLabel(null);
        } else {
          setCollapsedMenuLabel(menuItemInfo.label);
        }
      }
    } else {
      setIsMenuOpen(false);
      setCollapsedMenuLabel(null);
    }
  };

  const selectMenuSubsetItem = (item: menuSubItemType) => {
    router.push(item.link);
    setIsMenuOpen(false);
    setCollapsedMenuLabel(null);
  };

  return (
    <>
      <header
        className={`${styles.header}${light ? " " + styles.light : ""}${
          isMenuOpen ? " " + styles.openMenu : ""
        }`}
      >
        <button
          className={`${styles.menu}`}
          onClick={() => {
            setIsMenuOpen((pre) => !pre);
            document
              .querySelector("header")
              ?.setAttribute("style", "background-color: #2C343B");
          }}
          onMouseDown={rippleEffect}
          onTouchStart={rippleEffect}
          name="menu-button"
        >
          منو
          <i></i>
        </button>

        {!path.startsWith("/coins/") && (
          <div className={styles.buttonGroup}>
            <Link
              href={`${process.env.APP_PANEL_URL}/login`}
              onMouseDown={rippleEffect}
              onTouchStart={rippleEffect}
              draggable={false}
            >
              ورود
            </Link>
            <Link
              href={`${process.env.APP_PANEL_URL}/register`}
              onMouseDown={rippleEffect}
              onTouchStart={rippleEffect}
              draggable={false}
            >
              ثبت نام
            </Link>
          </div>
        )}

        <nav>
          <h2>لینک‌های اصلی</h2>

          <Link href="/" onClick={(e) => setIsMenuOpen(false)}>
            <svg
              height="24"
              viewBox="0 0 96 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.85452 16.7329C2.69621 16.686 2.53358 16.6542 2.36894 16.6382C2.11197 16.6118 1.85364 16.5999 1.59526 16.6027C1.34065 16.6001 1.0861 16.612 0.832904 16.6382C0.667032 16.6548 0.503115 16.6865 0.343281 16.7329C0.241496 16.7579 0.149142 16.8108 0.0770231 16.8852C0.0250775 16.9443 -0.00360705 17.0195 -0.00390625 17.0974V31.5043C-0.00389219 31.5823 0.0248279 31.6576 0.0770231 31.7166C0.147362 31.7907 0.237666 31.844 0.337616 31.8705C0.497267 31.9173 0.661266 31.9488 0.827239 31.9643C1.08234 31.9905 1.33877 32.0023 1.59526 31.9999C1.85364 32.0026 2.11197 31.9907 2.36894 31.9643C2.53354 31.9485 2.69617 31.917 2.85452 31.8705C2.95414 31.8438 3.04413 31.7905 3.1143 31.7166C3.1665 31.6576 3.19522 31.5823 3.19523 31.5043V17.0974C3.19493 17.0195 3.16625 16.9443 3.1143 16.8852C3.04398 16.8117 2.95399 16.759 2.85452 16.7329Z"
                fill={light ? "#292D32" : "white"}
              />
              <path
                d="M27.3035 16.7447C27.1667 16.6889 27.0216 16.6548 26.8738 16.6437C26.6449 16.6226 26.415 16.6128 26.1851 16.6145C25.9468 16.6125 25.7085 16.6222 25.4713 16.6437C25.3179 16.6565 25.1673 16.6905 25.0237 16.7447C24.9293 16.7777 24.8455 16.8346 24.7809 16.9096C24.733 16.9704 24.7073 17.0452 24.7081 17.1219V24.2776C24.7081 24.8199 24.714 25.3899 24.7259 25.9874C24.7378 26.585 24.7561 27.1586 24.7809 27.7083H24.768C24.6229 27.3927 24.474 27.0784 24.3213 26.7654C24.1686 26.4524 24.0113 26.1321 23.8495 25.8044C23.6876 25.4788 23.5201 25.1526 23.3469 24.826C23.1737 24.4993 22.9986 24.1671 22.8216 23.8294L19.7747 18.2533C19.6441 17.9858 19.4943 17.7277 19.3263 17.4809C19.2011 17.293 19.0437 17.1276 18.861 16.9917C18.6924 16.8725 18.5016 16.7864 18.2993 16.7384C18.0453 16.6819 17.7853 16.6554 17.5248 16.6595H15.8221C15.524 16.6508 15.233 16.7494 15.0047 16.9364C14.784 17.1211 14.6734 17.398 14.6729 17.7673V31.4815C14.672 31.5564 14.6931 31.63 14.7336 31.6937C14.7879 31.7668 14.8639 31.8218 14.9513 31.8515C15.0913 31.9033 15.2377 31.937 15.3867 31.9517C15.6193 31.978 15.8534 31.9898 16.0875 31.9872C16.326 31.99 16.5644 31.9781 16.8013 31.9517C16.952 31.9362 17.1002 31.9026 17.2424 31.8515C17.3329 31.8215 17.4127 31.7667 17.4722 31.6937C17.5159 31.6312 17.5391 31.5571 17.5386 31.4815V23.4996C17.5386 22.9026 17.5305 22.324 17.5143 21.7637C17.4981 21.2035 17.4738 20.6396 17.4415 20.0721H17.4657C17.6513 20.536 17.861 21.0134 18.0946 21.5042C18.3282 21.9949 18.558 22.4528 18.7841 22.8779L22.6776 30.0107C22.8424 30.339 23.0242 30.659 23.2223 30.9694C23.359 31.189 23.528 31.3878 23.724 31.5596C23.8874 31.6998 24.081 31.8025 24.2905 31.8602C24.5287 31.9177 24.7736 31.9442 25.0189 31.9391H26.3736C26.5271 31.9392 26.6798 31.9174 26.8268 31.8744C26.9699 31.8347 27.1021 31.7643 27.2137 31.6685C27.3255 31.5704 27.4142 31.4498 27.4735 31.315C27.5405 31.1622 27.5736 30.9974 27.5706 30.8313V17.1219C27.5717 17.047 27.5509 16.9734 27.5107 16.9096C27.4572 16.8364 27.3837 16.7793 27.2987 16.7447"
                fill={light ? "#292D32" : "white"}
              />
              <path
                d="M75.7999 29.7717C75.7694 29.691 75.7171 29.6199 75.6486 29.5658C75.5911 29.5232 75.5209 29.5002 75.4487 29.5003H69.8111V25.1969H74.539C74.6099 25.1976 74.6794 25.1773 74.7381 25.1385C74.8068 25.0891 74.8593 25.0214 74.8895 24.9436C74.9363 24.8285 74.9668 24.7078 74.9801 24.5846C75.0024 24.3969 75.0124 24.2079 75.0101 24.0189C75.012 23.8315 75.002 23.6441 74.9801 23.4579C74.9671 23.3327 74.9366 23.2097 74.8895 23.0926C74.8581 23.0141 74.8059 22.9452 74.7381 22.8929C74.6809 22.8504 74.611 22.8274 74.539 22.8274H69.8111V19.1024H75.3953C75.4657 19.103 75.5342 19.0802 75.5895 19.0377C75.6545 18.9815 75.7043 18.9105 75.7344 18.831C75.781 18.7115 75.8115 18.5866 75.825 18.4594C75.847 18.2737 75.857 18.0868 75.855 17.8999C75.8573 17.7049 75.8473 17.5099 75.825 17.3161C75.8108 17.1872 75.7804 17.0605 75.7344 16.9389C75.7069 16.8583 75.6567 16.787 75.5895 16.733C75.533 16.6934 75.4649 16.6726 75.3953 16.6738H67.5864C67.3413 16.6665 67.1021 16.7483 66.9155 16.9034C66.7342 17.0565 66.6436 17.3061 66.6436 17.6522V30.9505C66.6436 31.2969 66.7342 31.5455 66.9155 31.6993C67.1021 31.8544 67.3413 31.9362 67.5864 31.9289H75.4463C75.5184 31.9293 75.5886 31.9066 75.6462 31.8642C75.7147 31.8101 75.767 31.739 75.7975 31.6583C75.8437 31.5387 75.8741 31.4138 75.8881 31.2867C75.9281 30.9066 75.9281 30.5235 75.8881 30.1434C75.8741 30.0162 75.8437 29.8914 75.7975 29.7717"
                fill={light ? "#292D32" : "white"}
              />
              <path
                d="M95.9791 31.4223C95.908 31.1932 95.8128 30.9719 95.695 30.7619L91.986 24.0653L95.466 17.8407C95.5763 17.6246 95.6672 17.3997 95.7379 17.1684C95.7827 17.0032 95.7606 16.8775 95.6716 16.7912C95.5834 16.7045 95.4223 16.6524 95.186 16.6334C94.9497 16.6145 94.6332 16.6042 94.2302 16.6042C93.8677 16.6042 93.5836 16.6121 93.378 16.6279C93.2137 16.6373 93.051 16.6637 92.8925 16.7068C92.7947 16.7306 92.7064 16.7819 92.6383 16.8544C92.5798 16.9279 92.5293 17.0072 92.4878 17.0911L89.8171 22.1369L87.0712 17.0911C87.03 17.0071 86.9795 16.9277 86.9207 16.8544C86.8474 16.7796 86.7526 16.7281 86.6488 16.7068C86.4764 16.6641 86.3003 16.6377 86.1227 16.6279C85.901 16.6121 85.6005 16.6042 85.2212 16.6042C84.762 16.6042 84.4073 16.614 84.1569 16.6334C83.9077 16.654 83.7361 16.7045 83.6439 16.7865C83.5516 16.8686 83.5306 16.9956 83.5832 17.1645C83.6633 17.3977 83.7624 17.6243 83.8794 17.8422L87.3593 24.1024L83.6107 30.7634C83.4871 30.973 83.3857 31.1943 83.308 31.4239C83.2602 31.5888 83.2764 31.715 83.3566 31.801C83.4367 31.887 83.5929 31.9423 83.8227 31.9659C84.0525 31.9896 84.3771 32.0014 84.7939 32.0014C85.1564 32.0014 85.4486 31.9935 85.6703 31.9778C85.846 31.9684 86.0204 31.942 86.1907 31.8989C86.2937 31.8754 86.3879 31.8243 86.4626 31.7513C86.5249 31.6791 86.5776 31.5996 86.6196 31.5146L89.546 26.0087L92.4846 31.5146C92.5193 31.6007 92.5682 31.6807 92.6294 31.7513C92.7039 31.8246 92.7982 31.8757 92.9014 31.8989C93.0696 31.9417 93.2417 31.9682 93.4153 31.9778C93.6311 31.9935 93.9294 32.0014 94.3103 32.0014C94.7619 32.0014 95.1145 31.9896 95.3681 31.9659C95.6222 31.9423 95.797 31.887 95.8941 31.801C95.9912 31.715 96.0171 31.5888 95.9751 31.4239"
                fill={light ? "#292D32" : "white"}
              />
              <path
                d="M73.0978 0.190065C68.7647 3.90605 63.1894 5.95224 57.4186 5.94448C55.9164 5.9432 54.4177 5.80398 52.9424 5.52866L52.7417 6.19381C52.6653 6.35611 52.6009 6.52356 52.5491 6.69485L47.2433 23.6993L47.1988 23.5565L47.1543 23.6993L41.8478 6.69169C41.796 6.5204 41.7316 6.35296 41.6552 6.19066L41.4553 5.52866C39.9796 5.80394 38.4807 5.94316 36.9783 5.94448C31.2074 5.95224 25.6321 3.90605 21.299 0.190065C20.6322 -0.381195 19.6626 0.448867 20.1385 1.17951C23.57 6.45278 28.7451 10.4259 34.8077 12.4414L41.0005 30.227C41.0633 30.4579 41.1537 30.6809 41.2699 30.8913C41.3672 31.072 41.5083 31.2267 41.6811 31.3419C41.8848 31.4818 42.1106 31.5884 42.3495 31.6575C42.6879 31.7578 43.0367 31.8208 43.3895 31.8453C43.8265 31.8831 44.3404 31.9076 44.9441 31.9202C45.5479 31.9328 46.2803 31.9455 47.1414 31.9455H47.2555C48.1166 31.9455 48.849 31.9328 49.4527 31.9202C50.0564 31.9076 50.5703 31.8831 51.0074 31.8453C51.3604 31.8207 51.7095 31.7577 52.0481 31.6575C52.2867 31.5882 52.5122 31.4816 52.7158 31.3419C52.8885 31.2267 53.0297 31.072 53.1269 30.8913C53.2431 30.6809 53.3336 30.4579 53.3964 30.227L59.5891 12.4414C65.6532 10.4266 70.8299 6.45348 74.2624 1.17951C74.7383 0.448867 73.7687 -0.381195 73.1019 0.190065"
                fill="#2483FF"
              />
              <g style={{ mixBlendMode: "multiply" }}>
                <path
                  d="M72.979 2.97852C67.4733 9.98118 58.2895 11.4014 58.2895 11.4014L53.3965 30.227L59.5892 12.4406C64.9248 10.6673 69.5901 7.37046 72.979 2.97852Z"
                  fill="#BBBDBF"
                />
              </g>
              <g style={{ mixBlendMode: "multiply" }}>
                <path
                  d="M21.416 2.97852C26.9241 9.98118 36.1079 11.4014 36.1079 11.4014L41.0009 30.227L34.809 12.4406C29.472 10.6682 24.8054 7.37128 21.416 2.97852Z"
                  fill="#BBBDBF"
                />
              </g>
            </svg>
            <span>صرافی ارز دیجیتال اینوکس</span>
          </Link>

          {NavbarItems.map((item) => (
            <React.Fragment key={item.label}>
              <Link
                key={item.link}
                onClick={() => selectMenuItemHandler(item)}
                href={item.isCollapsable && isMobile ? "#" : item.link}
                className={`${styles.navbarItem} ${
                  path === item.link ? styles.active : ""
                }${item.active ? "" : " " + styles.deactive}`}
              >
                {item.label}
              </Link>
              {item.isCollapsable && item.label === collapsedMenuLabel && (
                <div className={styles.linkSubsets}>
                  {coins.map((menuSubsetItem, menuSubsetIndex) => (
                    <div
                      key={menuSubsetItem.id}
                      className={styles.linkSubsetsItem}
                      style={
                        menuSubsetIndex === 3 ? { border: "none" } : undefined
                      }
                      onClick={() => selectMenuSubsetItem(menuSubsetItem)}
                    >
                      {menuSubsetIndex !== 3 && (
                        <Image
                          src={`${process.env.APP_STORAGE_URL}/media/static/currency/logos/${menuSubsetItem.coin}/${menuSubsetItem.coin}.png`}
                          alt="لوگو"
                          loading="lazy"
                          width={24}
                          height={24}
                        />
                      )}
                      <p
                        className={styles.text}
                        style={
                          menuSubsetIndex === 3
                            ? { color: "#A9D7FF" }
                            : undefined
                        }
                      >
                        {menuSubsetItem.persian_name}{" "}
                        <span>{menuSubsetItem.coin}</span>
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </React.Fragment>
          ))}
        </nav>

        <div className={styles.buttons}>
          <Link
            href={`${process.env.APP_PANEL_URL}/login`}
            onMouseDown={rippleEffect}
            onTouchStart={rippleEffect}
            draggable={false}
          >
            ورود به حساب
          </Link>
          <Link
            href={`${process.env.APP_PANEL_URL}/register`}
            onMouseDown={rippleEffect}
            onTouchStart={rippleEffect}
            draggable={false}
          >
            ثبت نام
          </Link>
          <Link
            className="fi-tr-mobile-notch"
            href={`${process.env.APP_LANDING_URL}/media/static/app/app-release.apk`}
            onMouseDown={rippleEffect}
            onTouchStart={rippleEffect}
            draggable={false}
            download="invex.apk"
            target="_blank"
            title="mobile-notch"
          />
        </div>
      </header>
    </>
  );
}
